import { ContactDetails } from 'components/hook-page/user-details-hookpages/contact-details-hookpage/ContactDetails';
import React from 'react';

export const ContactDetailsHookPage: React.FC = () => {
    return <ContactDetails />;
};
